import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getCell = ({ row: tranche }: ITranchRow) => tranche.class;

const ClassCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="ClassCell"
    className={ alignStyles.alignLeft }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default ClassCell;
